export const COL_WIDTH = 35
export const MIN_CONTAINER_WIDTH = 770
export const MIN_COL_COUNT = 25
